var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "passwordDoubleCheck", class: { isPc: !_vm.isSp } },
      [
        _c(
          "InputLabel",
          {
            staticClass: "labelArea",
            class: {
              isPc: !_vm.isSp,
              isHasLabel: (!_vm.isSp && _vm.required) || _vm.labelWidthHasLabel,
              styleLabelWide: _vm.styleLabelWide,
            },
            attrs: { required: _vm.required },
          },
          [_vm._v("\n      " + _vm._s(_vm.areaLabel) + "\n    ")]
        ),
        _vm._v(" "),
        _c("InputItem", {
          staticClass: "inputItem",
          class: { hasError: _vm.hasErrorPassword1, isPc: !_vm.isSp },
          attrs: {
            "input-type": "password",
            "placeholder-value": "新しいパスワードを入力",
            disabled: _vm.disabled,
            "input-value": _vm.propPassword1,
            "is-new-password": true,
            "trim-space-start-end": "",
          },
          on: {
            blur: _vm.onBlurPassword1,
            change: _vm.onChangePassword1,
            focus: _vm.onFocusPassword1,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: {
          isPc: !_vm.isSp,
          isNoLabelInPc: !_vm.isSp && !_vm.required && !_vm.labelWidthHasLabel,
          styleLabelWide: _vm.styleLabelWide,
        },
      },
      [
        _c("InputItem", {
          staticClass: "inputItem",
          class: { hasError: _vm.hasErrorPassword2, isPc: !_vm.isSp },
          attrs: {
            "input-type": "password",
            "placeholder-value": "確認の為もう一度入力して下さい",
            disabled: _vm.disabled,
            "input-value": _vm.propPassword2,
            "is-new-password": true,
            "trim-space-start-end": "",
          },
          on: {
            blur: _vm.onBlurPassword2,
            change: _vm.onChangePassword2,
            focus: _vm.onFocusPassword2,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "validationErrorMessageArea" },
          [
            _c("PartialErrorMessage", {
              staticClass: "partialErrorComponent",
              attrs: { "is-sp-flg": true, error: _vm.displayErrorPassword1 },
            }),
            _vm._v(" "),
            _c("PartialErrorMessage", {
              staticClass: "partialErrorComponent",
              class: { hasTwoError: _vm.hasErrorPassword1 },
              attrs: { "is-sp-flg": true, error: _vm.displayErrorPassword2 },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.captionText
          ? _c(
              "CaptionText",
              {
                staticClass: "captionText",
                class: {
                  hasError: _vm.hasErrorPassword1 || _vm.hasErrorPassword2,
                  isPc: !_vm.isSp,
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.captionText) + "\n    ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }